<template>
  <div class="video-player-core">
    <video v-videoLogger class="player" preload="metadata" webkit-playsinline playsinline controls :poster="this.poster"></video>
  </div>
</template>

<script>
import { isSP, isEdge, isIos, isMacSafari, isIosChorome } from './utils/device'
import Hls from 'hls.js'
import Plyr from 'plyr'
import * as type from "@/utvStore/store/mutation-types";

export default {
  name: "VideoPlayerCore",
  data() {
    return {
      player: null,
      hls: null,
      isFirst: true,
      thumbnailWidth: 1920,
      thumbnailiHeight: 1080
    }
  },
  props: {
    videoSrc: { type: String, default(){return ''}},
    poster: { type: String, default(){return ''}},
    duration: { type: Number, default(){return -1}},
    episode: { type: Number, default(){return -1}},
    title: { type: String, default(){return ''}},
    sendInfo: {type: Object, default(){return {}}}
  },
  mounted() {
    this.playerInit()

    /*
    //↓↓↓↓↓以下TV側のソース（不要。参考のため一旦残す）↓↓↓↓↓
    // iosはタブ切り替え等でページを離れたら動画を止める
    if (isIos) {
      this.setPageVisibilityEvent()
    }

    // // videoタップ時にtap-highlightを表示させないため
    this.video.addEventListener('click', (e) => {})

    this.setDestroyWindowEvent()

    this.$on('played', () => this.played())
    this.$on('ended', () => this.ended())
    this.$on('seeking', () => this.seeking())
    this.$on('seeked', () => this.seeked())
    this.$on('pause', () => this.pause())
    this.$on('showCmTarget', () => this.cmControlLog('detail_button_display'))
    this.$on('clickCmTargetBtn', () => this.cmControlLog('detail_button_tap'))
    this.$on('showCmSkip', () => this.cmControlLog('skip_button_display'))
    this.$on('clickCmSkipBtn', () => this.cmControlLog('skip_button_tap'))
     */

  },
  methods: {
    playerInit(){
      const vid = this.$el.querySelector('.video-player-core .player')

      if(Hls.isSupported()){
        const config = { // fetchSetup必要ないかもしれなけど残す
          fetchSetup: function(context, initParams) {
            initParams.credentials = 'include';
            return new Request(context.url,initParams);
          }
        }
        this.hls = new Hls(config)
        this.hls.attachMedia(vid)
        this.hls.startLevel = 4
        this.player = new Plyr(vid, {
          resetOnEnd: true,
          i18n:{
            speed: '再生速度',
            normal: '標準',
          }
        })
        this.player.poster = this.poster

        this.player.on('loadedmetadata', () => this.setVideoSize(vid))
        this.player.on('play', event => {
          if(this.isFirst){
            // 最初に再生ボタンが押下されたタイミングでHLS読み込み
            this.isFirst = false
            this.hls.loadSource(this.videoSrc)
            this.$store.dispatch(type.SET_VIDEO_PLAY_HISTORY, this.sendInfo)
          }
        })
      }else if (vid.canPlayType('application/vnd.apple.mpegurl')) {
        //iosの場合
        vid.src = this.videoSrc
        const rate = window.innerWidth / this.thumbnailWidth
        vid.style.height = `${Math.round(this.thumbnailiHeight * rate)}px`
        vid.load()
        vid.addEventListener('playing', event => {
          if(this.isFirst) {
            // 最初に再生ボタンが押下されたタイミングでHLS読み込み
            this.isFirst = false
            this.$store.dispatch(type.SET_VIDEO_PLAY_HISTORY, this.sendInfo)
          }
          this.setVideoSize(vid)
        })
      }
    },
    setVideoSize(video){
      if(video.videoHeight / video.videoWidth > 1){
        //縦動画の場合はウィンドウ高さの70%の高さで固定とする
        video.style.height = `${window.innerHeight * 0.7}px`
      }
    }
    /*
    //↓↓↓↓↓以下TV側のソース（不要。参考のため一旦残す）↓↓↓↓↓
    play() {
      deleteDoneWatching(this.slug)
      this.video.play()

      if (this.isStreamingAd) {
        this.cmControlLog('cm_start')
      }
    },
    played() {
      clearTimeout(this.timerNextVod)
      if (this.nextAd && !this.isStreamingAd) {
        this.countStartAd()
      }
      this.isPlayed = true
      this.controls = true
      this.isEnded = false
      this.isCancelNext = false
      this.isPause = false
    },
    pause() {
      clearInterval(this.adCountTimer)
      this.isPause = true
      if (!this.canNotSaveStorage) {
        savePosition(this.slug, this.video.currentTime)
      }
    },
    ended() {
      if(this.isStreamingAd) {
        this.returnToVod()
      } else {
        if (!this.isSeeking) {
          this.finishVod()
        }
      }
    },
    seeking() {
      this.isSeeking = true
      clearInterval(this.adCountTimer)

      // Edgeはseekedイベントが発生しない場合があるので、
      // 3秒間seekされなかったら無理やりseekedイベントを発生させる
      if (isEdge) {
        window.setTimeout(() => {
          this.seeked()
        }, 3000)
      }
    },
    seeked() {
      this.isSeeking = false
      if (this.adsList.length && this.passNextAdTimer) {
        const currentTime = this.video.currentTime
        const spliceIndex = this.adsList.reduce((prevIndex, ad, index) => {
          if (ad.start_after_seconds <= currentTime) {
            return index + 1
          } else {
            return prevIndex
          }
        }, 0)
        this.adsList.splice(0, spliceIndex)
      }
      if (!this.isPause && this.nextAd) {
        if (Math.floor(this.video.currentTime) >= this.nextAd.start_after_seconds && this.passNextAdTimer) {
          this.playAdMovie()
        } else {
          this.countStartAd()
        }
      }
    },
    returnToVod() {
      this.cmControlLog('ads_finished')
      if (!isIos) {
        this.videoHls.attachHlsStreming()
      }
      this.setCurrentTime()
      if (!isMacSafari || !isIos) {
        this.video.play()
      }
      this.isStreamingAd = false
      this.nextAd = this.getNextAd()
      this.setNextAdTimer()
    },
    finishVod() {
      this.isEnded = true
      deletePosition(this.slug)
      setDoneWatchingList(this.slug)
      this.timerNextVod = window.setTimeout(() => {
        location.href = `${location.protocol}//${location.host}/movie/${this.nextVod.slug}/`
      }, 8000)
    },
    cmControlLog(eventType) {
      this.setAdLogData(eventType)
      this.ybiService.postPlayAd(this.adLogData)
    },
    initNextAdTimer() {
      const watchedCmIntervalTime = parseInt(sessionStorage.getItem('cmIntervalTime'), 10)

      if (watchedCmIntervalTime) {
        const nextAdTimer = this.baseAdInterval - (new Date().getTime() - watchedCmIntervalTime)
        if (nextAdTimer > 0) {
          this.passNextAdTimer = false
          window.setTimeout(() => {
            this.passNextAdTimer = true
          }, nextAdTimer)
        }
      }
    },
    setNextAdTimer() {
      this.passNextAdTimer = false
      this.adEndTime = new Date().getTime()
      window.setTimeout(() => {
        this.passNextAdTimer = true
      }, this.baseAdInterval)
    },
    cancelNext() {
      clearTimeout(this.timerNextVod)
      this.isCancelNext = true
    },
    //いっちゅう広告出稿に伴うデータ計測に関する対応 #5860
    // getAdParamForYBI() {
    //   const param = location.href.split('?')[1];
    //   const value = sessionStorage.getItem('ittechu');
    //   if ((param && param.indexOf('sokyaku=ittechu01') > -1) || value) {
    //     sessionStorage.setItem('ittechu', '1');
    //     return 'ittechu01'
    //   } else {
    //     sessionStorage.removeItem('ittechu');
    //     return ''
    //   }
    // }
    getNextAd() {
      const currentTime = this.currentTime
      const spliceIndex = this.adsList.reduce((prevIndex, ad, index) => {
        if (ad.start_after_seconds <= currentTime) {
          return index
        } else {
          return prevIndex
        }
      }, 0)
      const nextAdsList = this.adsList.splice(0, (spliceIndex + 1))

      if (nextAdsList.length) {
        return nextAdsList[0]
      } else if (this.adsList.length) {
        return this.adsList.splice(0, 1)[0]
      } else {
        return null
      }
    },
    setCurrentTime() {
      if (isIos) {
        if (this.isPlayed) {
          this.video.setAttribute('style', 'visibility: hidden')
        }
        this.video.src = this.vodSrc;
      } else {
        this.video.currentTime = this.currentTime
      }

      if (isIos) {
        this.video.load()
        this.video.oncanplay = () => {
          this.video.currentTime = this.currentTime;
          window.setTimeout(() => {
            this.video.setAttribute('style', 'visibility: visible')
            if (this.isPlayed) {
              this.video.play()
            }
            this.video.oncanplay = null
          }, 500)
        }
      }

      if (isMacSafari) {
        this.video.load()
        this.video.oncanplay = () => {
          this.video.currentTime = this.currentTime;
          if (this.isPlayed) {
            this.video.play()
          }
          this.video.oncanplay = null // seek時にhandler関数が動いてしまうため参照を切る
        }
      }
    },
    setStreamingAd() {
      this.isStreamingAd = true
      if (isIos) {
        this.video.src = this.nextAd.video_url
      } else {
        this.src = this.nextAd.video_url
      }
    },
    countStartAd() {
      this.adCountTimer = setInterval(() => {
        if (Math.floor(this.video.currentTime) >= this.nextAd.start_after_seconds && this.passNextAdTimer) {
          clearInterval(this.adCountTimer)
          this.playAdMovie()
        }
      }, 1000)
    },
    setAdLogData(eventType) {
      this.adLogData = {
        id: this.nextAd.id,
        title: this.title,
        slug: this.slug,
        ads_title: this.nextAd.title,
        ads_type: this.nextAd.ads_type,
        ads_duration: this.nextAd.duration,
        ads_start_after_seconds: this.nextAd.start_after_seconds,
        ads_video_url: this.nextAd.video_url,
        ads_link_url: this.nextAd.link_url,
        ads_is_browser: this.nextAd.is_browser,
        event_type: eventType,
      }
    },
    playAdMovie() {
      this.currentTime = this.video.currentTime
      this.video.currentTime = 0
      this.setStreamingAd()
      if (isIos) {
        this.video.play()
      } else {
        this.videoHls.detachHlsStreming()
        this.video.addEventListener('loadedmetadata',() => {
          this.video.play()
        })
      }
      this.cmControlLog('cm_start')
      savePosition(this.slug, this.currentTime)
    },
    setDestroyWindowEvent() {
      const hunder = () => {
        if (this.canNotSaveStorage) { return }
        savePosition(this.slug, this.video.currentTime)
        if (this.adEndTime > 0) {
          sessionStorage.setItem('cmIntervalTime', this.adEndTime.toString())
        }
      }
      if (isIos) {
        window.addEventListener('pagehide', hunder)
      } else {
        window.addEventListener('beforeunload', hunder)
      }
    },
    initControlElement() {
      this.controlsElem = document.getElementById('js-controls')
    },
    setPageVisibilityEvent() {
      let visibilityPause = false
      const handleVisibilityChange = (hidden) => {
        if (!this.isPlayed) return //再生前もしくは

        if (document[hidden]) {
          if (isIosChorome && !this.isStreamingAd) {
            this.currentTime = this.video.currentTime
          }
          if (this.isPause) return //停止中は特に何もしない
          this.video.pause();
          visibilityPause = true

        } else {
          // isoChromeは自動再生が安定しないので位置を戻すだけ
          if (isIosChorome) {
            if (!this.isStreamingAd) {
              this.video.setAttribute('style', 'visibility: hidden')
              this.video.load()
              this.video.oncanplay = () => {
                this.video.currentTime = this.currentTime;
                this.video.setAttribute('style', 'visibility: visible')
                // this.video.play()
                this.video.oncanplay = null
              }
            }
            // isoSafariは自動再生
          } else {
            if (visibilityPause) {
              this.video.play()
              visibilityPause = false
            }
          }
        }
      }
      pageVisibility(handleVisibilityChange.bind(this))
    }
    */
  }
}</script>
// @import "../../../../sass/components/_plyr.scss";
<style scoped lang="scss">
.video-player-core{
  height: 100%;
}
.player{
  width: 100%;
}
</style>
<style lang="scss">
.plyr__control--overlaid {
  background: #FF7497;
}
.plyr--full-ui input[type=range] {
  color: #FF7497;
}
.plyr--video .plyr__control.plyr__tab-focus, .plyr--video .plyr__control:hover, .plyr--video .plyr__control[aria-expanded=true] {
  background: #FF7497;
}

.plyr__control.plyr__tab-focus {
    box-shadow: 0 0 0 5px rgba(255, 116, 151, .5);
}
.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]:before {
    background: #FF7497;
}
.plyr__menu__container .plyr__control[role=menuitemradio][value="0.5"],
.plyr__menu__container .plyr__control[role=menuitemradio][value="0.75"],
.plyr__menu__container .plyr__control[role=menuitemradio][value="2"],
.plyr__menu__container .plyr__control[role=menuitemradio][value="4"]{
  display: none;
}
.plyr__menu__container .plyr__control--back{
  display: none;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/VideoPlayer/VideoPlayerCore.vue